import { useState, useEffect } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export default function ToastMessage(props) {
   const [position, setposition] = useState('top-right')
   useEffect(() => {
      if (props.show === true) {
         if(props.type == 'S'){
            toast.success(props.msg);
         }
         
         if (props.type == 'I') {
            toast.info(props.msg);
         }
         
         if (props.type == 'E') {
            toast.error(props.msg);
         }
         
         if (props.type == 'W') {
            toast.warning(props.msg);
         }
         
         if (props.position != undefined && props.position != null){
            setposition(props.position)
         } 
      }

   }, [props.show])

   return (
      <>
          <ToastContainer
            position={position}
            autoClose={3000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick={false}
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="light"
         /> 
      </>
   );
}